import FacebookConnectButton from './FacebookConnectButton';
import FacebookDisconnectButton from './FacebookDisconnectButton';
import FacebookGeneralSettings from './FacebookGeneralSettings';

const FacebookInitialSettings = ({
  facebookAccount,
  setFacebookAccount,
  handleChange,
  setTab,
  terms,
  termsLoading,
  syncProductsNow,
  syncAudiencesNow,
  isSuperAdmin,
  onFacebookAccountChange,
}) => {
  return (
    <>
      {facebookAccount ? (
        <>
          <FacebookGeneralSettings
            facebookAccount={facebookAccount}
            handleChange={handleChange}
            terms={terms}
            termsLoading={termsLoading}
            syncProductsNow={syncProductsNow}
            syncAudiencesNow={syncAudiencesNow}
            isSuperAdmin={isSuperAdmin}
            onFacebookAccountChange={onFacebookAccountChange}
          />
          <FacebookDisconnectButton
            facebookAccount={facebookAccount}
            setFacebookAccount={setFacebookAccount}
            setTab={setTab}
          />
        </>
      ) : (
        <FacebookConnectButton setFacebookAccount={setFacebookAccount} />
      )}
    </>
  );
};

export default FacebookInitialSettings;
